import {
  HomeOutlined,
  BookOutlined,
  DollarOutlined,
  UploadOutlined,
  RobotOutlined,
  UserOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import { getConfig } from "Config/config";
import { ROUTES } from "Features/Routes/routeConstants";
import { tiers } from "Constants";
import { useUserInfo } from "GlobalStates/User";
import { GraduationCap } from "lucide-react";

export const useSideBarItems = () => {
  const { FeatureCareer, FeatureImmigration, FeatureShopping, FeatureTravel } =
    getConfig();
  const { user } = useUserInfo();

  const sideBarItems = [
    {
      key: "1",
      icon: <HomeOutlined style={{ fontSize: "18px" }} />,
      label: "Home",
      target: ROUTES.DASHBOARD,
    },
    {
      key: "3",
      icon: <BookOutlined style={{ fontSize: "18px" }} />,
      label: "Colleges",
      target: ROUTES.COLLEGES,
    },
    {
      key: "5",
      icon: <DollarOutlined style={{ fontSize: "18px" }} />,
      label: "Finance",
      target: ROUTES.FINANCE,
    },
    {
      key: "13",
      icon: <GraduationCap style={{ fontSize: "18px" }} />,
      label: "Scholarship",
      target: ROUTES.FINANCE_SCHOLARSHIP,
    },
    {
      key: "6",
      icon: <RobotOutlined style={{ fontSize: "18px" }} />,
      label: "OG AI",
      target: ROUTES.CHAT_BOT,
    },
    {
      key: "7",
      icon: <UserOutlined style={{ fontSize: "18px" }} />,
      label: "Community",
      target: ROUTES.CONNECT_OG,
    },
  ];
  if (user?.tier !== tiers.MENTORED) {
    sideBarItems.push({
      key: "8",
      icon: <RiseOutlined style={{ fontSize: "18px" }} />,
      label: "Upgrade",
      target: ROUTES.PRICING,
    });
  }
  if (FeatureCareer) {
    sideBarItems.push({
      key: "9",
      icon: <UploadOutlined style={{ fontSize: "18px" }} />,
      label: "Career",
      target: "/career",
    });
  }

  if (FeatureImmigration) {
    sideBarItems.push({
      key: "10",
      icon: <UploadOutlined style={{ fontSize: "18px" }} />,
      label: "Immmigration",
      target: "/immigration",
    });
  }

  if (FeatureShopping) {
    sideBarItems.push({
      key: "11",
      icon: <UploadOutlined style={{ fontSize: "18px" }} />,
      label: "Shopping",
      target: "/shopping",
    });
  }

  if (FeatureTravel) {
    sideBarItems.push({
      key: "11",
      icon: <UploadOutlined style={{ fontSize: "18px" }} />,
      label: "Travel",
      target: "/travel",
    });
  }
  return sideBarItems;
};
